import { render, staticRenderFns } from "./HKVideo.vue?vue&type=template&id=9ef571e4&scoped=true"
import script from "./HKVideo.vue?vue&type=script&lang=js"
export * from "./HKVideo.vue?vue&type=script&lang=js"
import style0 from "./HKVideo.vue?vue&type=style&index=0&id=9ef571e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef571e4",
  null
  
)

export default component.exports